import { render, staticRenderFns } from "./vue-tabs-with-active-line.vue?vue&type=template&id=8a1ca02c"
import script from "./vue-tabs-with-active-line.vue?vue&type=script&lang=js"
export * from "./vue-tabs-with-active-line.vue?vue&type=script&lang=js"
import style0 from "./vue-tabs-with-active-line.vue?vue&type=style&index=0&id=8a1ca02c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports